import React, { useState } from "react";
import Header from "../Course/Header";
// import Banner from "../Course/Banner";
import Footer from "../Footer";
import { Button } from "@material-ui/core";
import "./UserInformation.css";
import { useHistory } from "react-router-dom";
import PeopleIcon from "@material-ui/icons/People";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

function UserInformation() {
  const history = useHistory();
  return (
    <div>
      <Header />
      <hr
        style={{
          width: "95%",
          marginTop: "-30px",
          marginBottom: "30px",
          height: "2px",
          marginLeft: "2.5%",
        }}
      />
      {/* <Banner /> */}
      <div className="st_info" style={{ margin: "80px 0 150px 0" }}>
        <div className="max-width">
          <h2>Welcome to Admin pages</h2>
          <div className="btn">
            <Button
              variant="contained"
              color="secondary"
              className="button"
              startIcon={<AccountCircleIcon />}
              onClick={() => history.push("/selectalladmin")}
            >
              Admins account
            </Button>
            <Button
              variant="contained"
              color="primary"
              href="#contained-buttons"
              className="button"
              startIcon={<PeopleIcon />}
              onClick={() => history.push("/listofstudent")}
            >
              Students Regis_infor
            </Button>
          </div>
        </div>
        <br /> <br />
        <hr
          style={{
            width: "75%",
            marginTop: "20px",
            marginBottom: "30px",
            height: "2px",
            marginLeft: "12.5%",
          }}
        />
        <div className="image-slide">
          <img src="/image/programming.jpg" alt="program" />
          <img src="/image/programming5.gif" alt="program" />
          <img src="/image/programming2.jpg" alt="program" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default UserInformation;
